import { BasketGiftPackagesShippingModel } from '../model/basket-overview-gift-form.model';

export class SaveBasketGiftPackageShippingPriceAction {
  static type = '[BASKET] Save gift packages shipping price';

  constructor(readonly shipping: BasketGiftPackagesShippingModel) {}
}
